import { useState } from "react"
import { ConfirmationDialog, Icon, Typography, Tooltip, IconButton } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { ConfigParams, ConfirmationDialogKeys } from "@tm/models"
import Morpheus from "@tm/morpheus"
import { CompilationModel, useDeleteCompilations } from "@tm/data/compilations"
import { isWM } from "../../../../../../utils"

type Props = {
    compilation: CompilationModel
    onOpenCompilations(): void
}

export function DeleteListButton({ compilation, onOpenCompilations }: Props) {
    const { deleteCompilations } = useDeleteCompilations(isWM())
    const { translateText } = useLocalization()
    const { deleteButtonColorError } = Morpheus.getParams<ConfigParams>()
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false)

    function handleDeleteDialogOpenStateChange() {
        setShowDeleteDialog((prev) => !prev)
    }

    const handlePartsWarningConfirm = () => {
        deleteCompilations([compilation.id])
        onOpenCompilations()
    }

    return (
        <>
            <Tooltip title={translateText(69)}>
                <IconButton
                    disabled={!compilation.isOwn}
                    onClick={handleDeleteDialogOpenStateChange}
                    size="large"
                    className="delete-compilation"
                    color={deleteButtonColorError ? "error" : undefined}
                    variant="contained"
                >
                    <Icon name="delete" />
                </IconButton>
            </Tooltip>
            <ConfirmationDialog
                open={showDeleteDialog}
                confirmationButtonText={translateText(585)}
                cancelButtonText={translateText(584)}
                onConfirm={handlePartsWarningConfirm}
                onCancel={handleDeleteDialogOpenStateChange}
                confirmationKey={ConfirmationDialogKeys.DeleteCompilations}
            >
                <Typography>{translateText(1313)}</Typography>
            </ConfirmationDialog>
        </>
    )
}
